export enum TicketStatus {
  reserved = 'reserved',
  sold = 'sold',
  available = 'available',
  used = 'used',
  expired = 'expired',
}

export interface TicketModel {
  id: number,
  event_id: number,
  product_id: number,
  contact_id: number,
  status: TicketStatus,
  seller_id?: Nullable<number>,
  invoice_id?: Nullable<number>,
  sold_price?: Nullable<number>,
  first_name?: Nullable<string>,
  last_name?: Nullable<string>,
  email?: Nullable<string>,
  phone?: Nullable<string>,
  ticket_identifier?: Nullable<string>,
  payment_status?: Nullable<string>,
  is_sent_by_email?: boolean,
  is_sent_by_sms?: boolean,
}
